export default "__VITE_ASSET__Cbl7iWre__"